<template>
  <div class="i-team-multi-picker">
    <div class="field-label">
      {{ label }}
    </div>
    <multiselect
      v-model="selected"
      label="name"
      trackBy="id"
      :options="sharedFolders"
      :multiple="false"
      :placeholder="placeholder"
      @search-change="onSearch"
      @select="onSelect"
      @remove="onRemove"
    />
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import {listSharedFolders} from "@/services/api/dropbox/recovery/shared-folder/sharedFolder";
import {defaultPagination} from "@/services/pagination";

export default {
  name: 'ISharedFolderPicker',
  components: {Multiselect},
  props: {
    value: {},
    label: {
      type: String,
      default: 'Team folder'
    },
    placeholder: {
      type: String,
      default: 'Search for team folders here'
    },
    filter: {
      type: Object,
      default: {
        "statuses": [
          1, 2, 4
        ]
      }
    }
  },

  data() {
    return {
      selected: null,
      sharedFolders: []
    }
  },

  methods: {
    onSearch(searchTerm) {
      this.sharedFolders = [];
      this.loadSharedFolders(searchTerm)
    },
    loadSharedFolders(search = null) {
      listSharedFolders({
        pagination: {
          ...defaultPagination(),
          pageSize: 30,
          sortBy: 'name',
          sortDescending: false
        },
        search,
        filter: this.filter
      })
        .then(({result, pagination}) => {
          this.sharedFolders = result;
        })
    },
    onSelect(data) {
      this.$emit('input', data)
    },
    onRemove(data) {
      this.$emit('input', null)
    }
  },

  created() {
    if (this.value?.status != 4) {
      this.selected = this.value;
    }

    this.loadSharedFolders();
  },
}
</script>

<style lang="scss">
@import "ITeamPicker.scss";
</style>
